export default String.raw`
{% capture shopBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% if page.PageId == config.DefinedPages.ProductDetails.Id and customer.CurrencyExt.Code == 'PLN' -%}
    {% assign isSantanderCalculator = false -%}
    {% if settings.SantanderCalculator == 'yes' and settings.SantanderCalculatorID != '' -%}
        {% assign isSantanderCalculator = true -%}
    {% endif -%}

    {% assign isAgricoleCalculator = false -%}
    {% if settings.AgricoleCalculator == 'yes' and settings.AgricoleCalculatorID != '' -%}
        {% assign isAgricoleCalculator = true -%}
    {% endif -%}

    {% assign isiRatyCalculator = false -%}
    {% if settings.iRatyCalculator == 'yes' and settings.iRatyCalculatorID != '' -%}
        {% assign isiRatyCalculator = true -%}
    {% endif -%}

    {% assign isiLeasingCalculator = false -%}
    {% if settings.iLeasingCalculator == 'yes' and settings.iLeasingCalculatorID != '' -%}
            {% assign isiLeasingCalculator = true -%}
    {% endif -%}
    
    {% assign isGrenkeCalculator = false -%}
    {% if settings.grenkeCalculator == 'yes' -%}
        {% unless config.ENTERPRISE == false and customer.SubtotalPrices == false -%}
            {% assign isGrenkeCalculator = true -%}
        {% endunless -%}
    {% endif -%}

{% elsif page.PageId == config.DefinedPages.Order.Id and customer.CurrencyExt.Code == 'PLN' -%}
    {% assign isSantanderCalculator = false -%}
    {% if settings.SantanderCalculator == 'yes' and settings.SantanderCalculatorID != '' and cart.OrderTotalValue >= 100 -%}
        {% assign isSantanderCalculator = true -%}
    {% endif -%}

    {% if settings.AgricoleCalculator == 'yes' and settings.AgricoleCalculatorID != '' and cart.OrderTotalValue >= 100 -%}
        {% assign isAgricoleCalculator = true -%}
    {% endif -%}

    {% assign isiRatyCalculator = false -%}
    {% if settings.iRatyCalculator == 'yes' and settings.iRatyCalculatorID != '' and cart.OrderTotalValue >= 300 -%}
        {% assign isiRatyCalculator = true -%}
    {% endif -%}

    {% assign isiLeasingCalculator = false -%}
    {% assign isGrenkeCalculator = false -%}
{% endif -%}


{% if page.PageId == config.DefinedPages.ProductDetails.Id and customer.CurrencyExt.Code == 'PLN' -%}
    {% if product.Clip == false and product.Supplies == null and product.AttributesPolyvalent[0] -%}
        {% assign isSantanderCalculator = false -%}
        {% assign isAgricoleCalculator = false -%}
        {% assign isiLeasingCalculator = false -%}
        {% assign isiRatyCalculator = false -%}
        {% assign isGrenkeCalculator = false -%}
    {% endif -%}
{% endif -%}

{% if isSantanderCalculator or isAgricoleCalculator or isiRatyCalculator or isGrenkeCalculator or isiLeasingCalculator -%}
    <div class="installmentCalculator">
        {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
            <input type="hidden" value="{{product.Price}}" id="installmentCalculatorPrice">
        {% elsif page.PageId == config.DefinedPages.Order.Id -%}
            <input type="hidden" value="{{cart.OrderTotalValue}}" id="installmentCalculatorPrice">
        {% endif -%}

        <script type="text/javascript">
            var ratio = 1;
            function reloadInstallmentButtons(newRatio = ratio) {
                if (ratio != newRatio) {
                    ratio = newRatio;
                }
                if ($('.installmentCalculator').length > 0) {
                    {% assign subtotalPrice = activeProduct.Price -%}

                    {% if customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
                        {% if activeProduct.TotalPrice != null -%}
                            {% assign subtotalPrice = activeProduct.TotalPrice -%}
                        {% endif -%}
                    {% endif -%}

                    {% if product.Clip -%}
                        var quantity = $('.child-js.active-js').find('[name=quantity]').val();
                    {% else -%}
                        var quantity = $('[name=quantity]').val();
                    {% endif -%}

                    {% assign subtotalPrice = subtotalPrice|ToString|Replace:',','.' -%}
                    let subtotalPrice = parseFloat('{{subtotalPrice}}').toFixed(2);
                    subtotalPrice = subtotalPrice * quantity * ratio;
                    subtotalPrice = subtotalPrice.toString().replace(',', '.');

                    $('#installmentCalculatorPrice').val(subtotalPrice);
                    let isInstallment = false;

                    if (subtotalPrice >= 100) {
                        $('.creditAgricoleRaty-js').removeClass('hidden-js');
                        $('.eRatySantander-js').removeClass('hidden-js');
                        isInstallment = true;
                    } else {
                        $('.creditAgricoleRaty-js').addClass('hidden-js');
                        $('.eRatySantander-js').addClass('hidden-js');
                    }

                    if (subtotalPrice >= 300) {
                        $('.iRaty-js').removeClass('hidden-js');
                        isInstallment = true;
                    } else {
                        $('.iRaty-js').addClass('hidden-js');
                    }

                    {% assign subtotalPrice = activeProduct.SubtotalPrice -%}
                    subtotalPrice = parseFloat('{{subtotalPrice}}').toFixed(2);
                    subtotalPrice = subtotalPrice * quantity * ratio;
                    subtotalPrice = subtotalPrice.toString().replace(',', '.');

                    if (subtotalPrice >= 1500) {
                        $('.grenkeLeasing-js').removeClass('hidden-js');
                        isInstallment = true;
                    } else {
                        $('.grenkeLeasing-js').addClass('hidden-js');
                    }

                    if (isInstallment) {
                        $('.installmentCalculator').removeClass('hidden-js');
                    } else {
                        if ($('.iLeasing-js').index() >= 0) {
                            $('.installmentCalculator').removeClass('hidden-js');
                        } else {
                            $('.installmentCalculator').addClass('hidden-js');
                        }
                    }
                }
            }

            function calculateInstallment(type) {
                let value = $('#installmentCalculatorPrice').val().replace(',', '.');

                {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
                    {% assign subtotalPrice = activeProduct.Price -%}

                    {% if customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
                        {% if activeProduct.TotalPrice != null -%}
                            {% assign subtotalPrice = activeProduct.TotalPrice -%}
                        {% endif -%}
                    {% endif -%}

                    {% if product.Clip -%}
                        var quantity = $('.child-js.active-js').find('[name=quantity]').val();
                    {% else -%}
                        var quantity = $('[name=quantity]').val();
                    {% endif -%}

                    {% assign subtotalPrice = subtotalPrice|ToString|Replace:',','.' -%}
                    let subtotalPrice = parseFloat('{{subtotalPrice}}').toFixed(2);
                    subtotalPrice = subtotalPrice * quantity * ratio;
                    subtotalPrice = subtotalPrice.toString().replace(',', '.');
                {% endif -%}
                
                if (type === 'eRatySantander') {
                    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
                        window.open('https://wniosek.eraty.pl/symulator/oblicz/numerSklepu/{{settings.SantanderCalculatorID}}/typProduktu/0/wartoscTowarow/'+subtotalPrice, 'Policz_rate','width=640,height=500,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no');
                    {% elsif page.PageId == config.DefinedPages.Order.Id -%}
                        window.open('https://wniosek.eraty.pl/symulator/oblicz/numerSklepu/{{settings.SantanderCalculatorID}}/typProduktu/0/wartoscTowarow/'+value, 'Policz_rate','width=640,height=500,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no');
                    {% endif -%}

                } else if (type === 'CreditAgricoleRaty') {
                    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
                        window.open('https://ewniosek.credit-agricole.pl/eWniosek/simulator.jsp?PARAM_TYPE=RAT&PARAM_PROFILE={{settings.AgricoleCalculatorID}}&PARAM_CREDIT_AMOUNT=' + subtotalPrice, '', 'width=640,height=500,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no');
                    {% elsif page.PageId == config.DefinedPages.Order.Id -%}
                        window.open('https://ewniosek.credit-agricole.pl/eWniosek/simulator.jsp?PARAM_TYPE=RAT&PARAM_PROFILE={{settings.AgricoleCalculatorID}}&PARAM_CREDIT_AMOUNT=' + value, '', 'width=640,height=500,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no');
                    {% endif -%}

                } else if (type === 'iRaty') {
                    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
                        window.open('https://www.platformaratalna.pl/kalkulator/{{settings.iRatyCalculatorID}}/' + subtotalPrice);
                    {% elsif page.PageId == config.DefinedPages.Order.Id -%}
                        window.open('https://www.platformaratalna.pl/kalkulator/{{settings.iRatyCalculatorID}}/' + value.replace(',', '.'));
                    {% endif -%}
                } else if (type === 'iLeasing') {
                    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
                        {% if config.ENTERPRISE -%}
                            {% assign subtotalPrice = activeProduct.SubtotalPrice -%}
                        {% else -%}
                            {% assign subtotalPrice = activeProduct.Price -%}
                        {% endif -%}

                        {% if product.Clip -%}
                            var quantity = $('.child-js.active-js').find('[name=quantity]').val();
                        {% else -%}
                            var quantity = $('[name=quantity]').val();
                        {% endif -%}

                        {% assign subtotalPrice = subtotalPrice|ToString|Replace:',','.' -%}
                        let subtotalPrice = parseFloat('{{subtotalPrice}}').toFixed(2);
                        subtotalPrice = subtotalPrice * quantity * ratio;
                        subtotalPrice = subtotalPrice.toString().replace(',', '.');
                    {% elsif page.PageId == config.DefinedPages.Order.Id -%}
                    {% endif -%}
                    window.open('https://www.platformafinansowa.pl/wniosek/leasing/{{settings.iLeasingCalculatorID}}/' + subtotalPrice);
                } else if (type === 'Grenke') {
                    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
                        {% if config.ENTERPRISE -%}
                            {% assign subtotalPrice = activeProduct.SubtotalPrice -%}
                        {% else -%}
                            {% assign subtotalPrice = activeProduct.Price -%}
                        {% endif -%}

                        {% assign subtotalPrice = subtotalPrice|ToString|Replace:',','.' -%}
                        let subtotalPrice = parseFloat('{{subtotalPrice}}').toFixed(2);
                        subtotalPrice = subtotalPrice * ratio;

                        {% if product.Clip -%}
                            var quantity = $('.child-js.active-js').find('[name=quantity]').val();
                            {% assign images = activeProduct.ImagesExt -%}
                        {% else -%}
                            var quantity = $('[name=quantity]').val();
                            {% assign images = product.Images -%}
                        {% endif -%}

                        {% assign imagesSize = images | Size -%}
                        {% if imagesSize > 0 -%}
                            {% if images[0].Id > 0 -%}
                                {% capture imgUrl -%}{{ shopBase }}img/{{ images[0].Id }}/{{ images[0].Link }}.jpg{% endcapture -%}
                            {% elseif product.Image.Id > 0 -%}
                                {% capture imgUrl -%}{{ shopBase }}img/{{ product.Image.Id }}/{{ product.Image.Link }}.jpg{% endcapture -%}
                            {% else -%}
                                {% capture imgUrl -%}{{product.Image.ExternalUrl}}{% endcapture -%}
                            {% endif -%}
                        {% endif -%}
                        
                        $.post('endpoint/4?type=1', JSON.stringify([{"name":"{{activeProduct.NameNoHtml|H|Truncate:100|Replace: '\\', ''|Replace: '\/', ''}}","count":Number(quantity),"price":subtotalPrice.toFixed(2).toString().replace(',','.'){% if imagesSize > 0 -%},"photo":"{{imgUrl}}"{% endif -%}}]), function(res){window.open(res.redirectUrl, '_blank')});
                    {% elsif page.PageId == config.DefinedPages.Order.Id -%}
                        var products = [];
                        {% for product in cart.Products -%}
                            {% if config.ENTERPRISE -%}
                                {% assign subtotalPrice = product.SubtotalPrice -%}
                            {% else -%}
                                {% assign subtotalPrice = product.Price -%}
                            {% endif -%}

                            {% if product.Image.Id > 0 -%}
                                {% capture imgUrl -%}{{ shopBase }}img/{{ product.Image.Id}}/{{ product.Image.Link }}.jpg{% endcapture -%}
                            {% else -%}
                                {% capture imgUrl -%}{{product.Image.ExternalUrl}}{% endcapture -%}
                            {% endif -%}
                            products.push([{"name": "{{product.NameNoHtml|Truncate:100}}","count":Number({{product.Quantity}}),"price":{{subtotalPrice|ToString|Replace:',','.'}},"photo":"{{imgUrl}}"}]);
                        {% endfor -%}
                        $.post('endpoint/4?type=2', products, function(res){window.open(res.redirectUrl, '_blank')});
                    {% endif -%}
                }
            }
        </script>
        
        {% if isSantanderCalculator -%}
            <button class="installmentCalculator--btn eRatySantander-js" OnClick="calculateInstallment('eRatySantander')"> 
                <img src="css/img/alo.gif" data-src="https://www.eraty.pl/images/bannery/oblicz_white.png" alt="{{translations.InstallmentCalculator}}" width="100" height="20">
            </button>
        {% endif -%}

        {% if isAgricoleCalculator -%}
            <button class="installmentCalculator--btn creditAgricoleRaty-js" OnClick="calculateInstallment('CreditAgricoleRaty')">
                <img src="css/img/alo.gif" data-src="https://ewniosek.credit-agricole.pl/eWniosek/res/buttons/calc_md_full.png" alt="{{translations.InstallmentCalculator}}" width="120" height="20">
            </button>
        {% endif -%}

        {% if isiRatyCalculator -%}
            <button class="installmentCalculator--btn iRaty-js" OnClick="calculateInstallment('iRaty')">
                <img src="css/img/alo.gif" data-src="https://www.platformaratalna.pl/assets/button/09.png" alt="{{translations.InstallmentCalculator}}" width="80" height="24">
            </button>
        {% endif -%}

        {% if isGrenkeCalculator -%}
            <button class="installmentCalculator--btn grenkeLeasing-js" OnClick="calculateInstallment('Grenke')">
                <img class="grenke-leasing-js" src="css/img/alo.gif" data-src="https://newonline.leasingoptymalny.pl/online/img/w5.jpg" alt="Grenke Leasing" width="112" height="20">
            </button>
        {% endif -%}

        {% if isiLeasingCalculator -%}
            <button class="installmentCalculator--btn iLeasing-js" OnClick="calculateInstallment('iLeasing')">
                <img src="css/img/alo.gif" data-src="https://www.platformafinansowa.pl/assets/button/09.png" alt="iLeasing" width="80" height="24">
            </button>
        {% endif -%}
    </div> 
{% endif -%}
`